import { v4 as uuid } from 'uuid';
export class ProductAddon {
    id;
    name = null;
    price = 0;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductOptionValue {
    id = null;
    name = null;
    correction = 0;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductOption {
    id;
    name = null;
    possibleValues = [];
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'possibleValues' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductOptionValue(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    getValueById(id) {
        if (id) {
            for (let possibleValue of this.possibleValues) {
                if (possibleValue.id == id) {
                    return possibleValue;
                }
            }
        }
        return null;
    }
}
export class ProductSlotItem {
    id = null;
    productId = null;
    correction = 0;
    hidden = false;
    sortOrder = 0;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductSlot {
    id;
    name = null;
    availableProducts = [];
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'availableProducts' && Object.values(value).length > 0) {
                            //convert it from map to array with id
                            let idList = [];
                            if (typeof value == 'object' && !Array.isArray(value)) {
                                for (let id in value) {
                                    let o = value[id];
                                    o.id = id;
                                    idList.push(o);
                                }
                            }
                            else {
                                idList = value;
                            }
                            let items = [];
                            for (let item of idList) {
                                items.push(new ProductSlotItem(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    hasProductId(productId) {
        return this.availableProducts.filter((a) => a.id == productId).length > 0;
    }
    getSlotItemById(id) {
        if (id) {
            for (let item of this.availableProducts) {
                if (item.id == id) {
                    return item;
                }
            }
        }
        return null;
    }
}
export var ProductType;
(function (ProductType) {
    ProductType["regular"] = "regular";
    ProductType["combined"] = "combined";
})(ProductType || (ProductType = {}));
export class Product {
    id = null;
    companyId = null;
    name = null;
    description = null;
    sortOrder = 0;
    type = ProductType.regular;
    price = 0;
    weight = 0;
    addons = [];
    options = [];
    slots = [];
    tags = null;
    vatRate = null;
    locationId = null;
    productionTime = null;
    productionTimeIsSplittable = true;
    productionTimeIsConstrainedToOpeningHours = false;
    categoryId = null;
    defaultCourseId = null;
    numberOfItemsInStock = null;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'addons' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductAddon(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'options' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductOption(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'slots' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductSlot(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    getAddonById(addonId) {
        if (addonId) {
            for (let addon of this.addons) {
                if (addon.id == addonId) {
                    return addon;
                }
            }
        }
        return null;
    }
    getOptionById(optionId) {
        if (optionId) {
            for (let option of this.options) {
                if (option.id == optionId) {
                    return option;
                }
            }
        }
        return null;
    }
}
